export default __webpack_public_path__ + "static/media/SimplyServe.ce365022.png";